/**
 * 🍦 FROSTY FLOW PWA
 * Queensland Stadium App
 */

import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { SplashPage } from './pages/Splash';
import { MenuPage } from './pages/Menu';
import { CartPage } from './pages/Cart';
import { CheckoutPage } from './pages/Checkout';
import { OrderStatusPage } from './pages/OrderStatus';
import { OrderHistoryPage } from './pages/OrderHistory';
import { AdminPage } from './pages/Admin';
import { NavigatePage } from './pages/Navigate';
import { DirectionsPage } from './pages/Directions';
import { MapPage } from './pages/Map';
import { EmergencyPage } from './pages/Emergency';
import { ProfilePage } from './pages/Profile';
import { FunPage } from './pages/Fun';
import { EntryPage } from './pages/Entry';
import { BigScreenPage } from './pages/BigScreen';
import { MeetingSpotsPage } from './pages/MeetingSpots';

export default function App() {
  return (
    <Routes>
      {/* Splash Screen - FIRST THING YOU SEE */}
      <Route path="/" element={<SplashPage />} />
      
      {/* Main App with Bottom Nav */}
      <Route path="/menu" element={<Layout />}>
        <Route index element={<MenuPage />} />
      </Route>
      <Route path="/cart" element={<CartPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/order/:id" element={<OrderStatusPage />} />
      <Route path="/orders" element={<OrderHistoryPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/navigate" element={<Layout />}>
        <Route index element={<NavigatePage />} />
      </Route>
      <Route path="/directions" element={<DirectionsPage />} />
      <Route path="/map" element={<Layout />}>
        <Route index element={<MapPage />} />
      </Route>
      <Route path="/profile" element={<Layout />}>
        <Route index element={<ProfilePage />} />
      </Route>
      <Route path="/fun" element={<Layout />}>
        <Route index element={<FunPage />} />
      </Route>
      
      {/* Emergency Mode (Full Screen) */}
      <Route path="/emergency" element={<EmergencyPage />} />

      {/* Meeting Spots (Full Screen) */}
      <Route path="/meeting-spots" element={<MeetingSpotsPage />} />
      
      {/* Stadium Entry - QR Code Landing */}
      <Route path="/entry" element={<EntryPage />} />
      
      {/* Big Screen - Stadium Display with QR */}
      <Route path="/bigscreen" element={<BigScreenPage />} />
    </Routes>
  );
}
